<template>
  <div>
    <!-- 头部 -->
    <top></top>
    <el-row>
      <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
        <!-- logo -->
        <div class="logo">
          <img v-if="bannerArr.length > 0" :src="$imgUrl+bannerArr[0].thumb" alt="" />
        </div>
        <!-- 内容区 -->
        <div class="container" v-if="builderdetail.lists">
          <div
            v-for="(item, index) in builderdetail.lists"
            :key="index"
            class="container_item"
          >
            <div class="h2-title">
              {{ langSet == "cn" ? item.title : item.en_title }}
            </div>
            <div class="company_box">
              <div class="company_info_box">
                <div
                  class="conmpany_left"
                  v-html="
                    langSet == 'cn' ? item.left_content : item.en_left_content
                  "
                ></div>
                <div
                  class="conmpany_right"
                  v-html="
                    langSet == 'cn' ? item.right_content : item.en_right_content
                  "
                >
                </div>
              </div>
            </div>
          </div>
        </div>
      </el-col>
    </el-row>
    <!-- 底部 -->
    <bottom></bottom>
  </div>
</template>

<script>
import top from "../../components/top.vue";
import bottom from "../../components/bottom.vue";
import { getBanner, getBuilderLists } from "@/api/api";
export default {
  components: { top, bottom },
  name: "home",
  // 配置title和meta数据
  metaInfo() {
    return {
      title:this.langSet=='cn'?this.keydata.name_cn:this.keydata.name_en,
      meta: [
        {
          name: "description",
          content: this.keydata.description,
        },
        {
          name: "keywords",
          content: this.keydata.keywords,
        },
      ],
    };
  },
  data() {
    return {
      langSet: "",
      bannerArr: [],
      builderdetail: {},
      keydata:{}
    };
  },
  created() {},
  activated(){
     let menuArr=JSON.parse(localStorage.getItem('menuArr'))
     menuArr.map(item=>{
       if(item.name_cn=='展会服务'||item.name_en=='Exhibition services'){
            console.log(item,"item")
            this.keydata=item;
            
       }
     })
    
  },
  mounted() {
    this.langSet = localStorage.getItem("languageSet") || "cn";
    this.getBannerList();
    this.getBuilder();
  },
  methods: {
    // zhang 获取展会服务banner
    getBannerList() {
      let data = {
        class: "展会服务",
        lang_type: this.langSet,
      };
      getBanner(data)
        .then((res) => {
          if (res.code == 1) {
            this.bannerArr = res.data.lists;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // zhang 展会服务
    getBuilder() {
      let data = {};
      getBuilderLists(data)
        .then((res) => {
          if (res.code == 1) {
            this.builderdetail = res.data;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.logo {
  width: 100%;
  height: 400px;
  img {
    width: 100%;
    height: 400px;
  }
}
.container {
  // width: 1280px;
  margin: 0 auto;
  padding: 50px 0;
  box-sizing: border-box;
  .container_item {
    margin-bottom: 50px;
  }
  .title {
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    font-size: 28px;
    color: #009ffc;
  }
  .company_box {
    background: rgba(171, 181, 205, 0.1);
    margin-top: 30px;
    padding: 50px 50px 50px 64px;
    box-sizing: border-box;
    .company_logo {
      width: 380px;
      height: 51px;
      // background: #fff;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .company_info_box {
      display: flex;
      .conmpany_left {
        width: 500px;
        .conmpany_title_box {
          display: flex;
          margin: 30px 0 15px;
          font-family: PingFangSC, PingFang SC;
          .title_box1 {
            font-weight: 600;
            font-size: 22px;
            color: #2c2c2e;
          }
          .title_box2 {
            font-weight: 400;
            font-size: 20px;
            color: #007aff;
            margin-left: 30px;
            border-bottom: 1px solid #007aff;
            display: inline-block;
          }
        }
        .conmpany_content {
          font-family: PingFangSC, PingFang SC;
          font-weight: 400;
          font-size: 16px;
          color: #2c2c2e;
          line-height: 22px;
        }
      }
      .conmpany_right {
        width: 616px;
        background: #ffffff;
        border-radius: 20px;
        padding: 30px 25px;
        box-sizing: border-box;
        margin-left: 50px;
        .contact_box {
          display: flex;
          .contact_item:nth-child(1) {
            margin-right: 92px;
          }
        }
        .conmpany_right_title {
          display: inline-block;
          font-family: PingFangSC, PingFang SC;
          font-weight: 500;
          font-size: 18px;
          color: #2c2c2e;
          border-bottom: 2px solid #243889;
          line-height: 25px;
          height: 25px;
          margin-right: 20px;
          margin-bottom: 10px;
        }
        .conmpany_bottom {
          margin-bottom: 20px;
        }
        .conmpany_right_contents {
          font-family: PingFangSC, PingFang SC;
          font-weight: 400;
          font-size: 18px;
          color: #2c2c2e;
          line-height: 25px;
        }
      }
    }
  }
}
@media only screen and (max-width: 767px) {
  .container {
    padding: 50px 0 !important;
    .title {
      font-size: 18px !important;
    }
  }

  .company_info_box {
    display: inline-block !important;
    width: 100%;
  }
  .company_logo {
    width: 100% !important;
  }
  .conmpany_left {
    width: 100% !important;
  }
  .conmpany_right {
    width: 100% !important;
    margin: 0 !important;
    padding: 0 !important;
    border-radius: 0 !important;
    background: transparent !important;
    margin-top: 30px !important;
  }
  .contact_box {
    display: block !important;
  }
  .company_box {
    padding: 20px 15px 30px !important;
    .company_info_box {
      .conmpany_left {
        .conmpany_title_box {
          display: block !important;
          .title_box1 {
            font-size: 18px !important;
          }
          .title_box2 {
            margin-left: 0 !important;
            font-size: 15px !important;
            margin-top: 5px !important;
          }
        }
      }
    }
  }
  .logo {
    height: 81px !important;
    margin-top: 0.88rem;
    img {
      height: 81px !important;
    }
  }
  .conmpany_content {
    font-size: 14px !important;
  }
  .conmpany_right_contents {
    font-size: 14px !important;
  }
  .conmpany_right_title {
    font-size: 16px !important;
  }
}
</style>